export const isUserPremium = (user) => {
  if (!user) return false;
  if (user.isPremium) return true;
  if (['admin', 'superadmin', 'moderator'].includes(user.role)) return true;
  if (user.trialUsed && user.trialStartDate) {
    if (user.trialEndsAt) {
      return Date.now() < new Date(user.trialEndsAt).getTime();
    }
    const daysDiff = (Date.now() - new Date(user.trialStartDate).getTime()) / (1000 * 60 * 60 * 24);
    return daysDiff <= 30;
  }
  return false;
};
